import classNames from 'classnames'
import React from 'react'
import { PlanDetailType } from 'service/plans'

export const FunctionBox = ({
  planDetail,
  planId,
  index,
}: {
  planDetail: PlanDetailType
  planId: number
  index: number
}) => {
  return (
    <>
      {planDetail.type === 'function' && (
        <p
          className={classNames(
            'font-bold text-[18px] flex items-center gap-[3px] mb-[24px]'
          )}
          key={`plan_detail_${index}`}
        >
          <img
            src={
              planDetail.highlight
                ? 'assets/img/check_circle_red.png'
                : planId === 5
                ? 'assets/img/check_circle_blue.png'
                : 'assets/img/check_circle.png'
            }
            alt="check_circle"
            width={24}
            height={24}
          />
          <span className="relative w-full 1">
            <span
              className={`relative inline-block ${
                planDetail.highlight
                  ? 'after:absolute after:left-0 after:bottom-[2px] after:w-full after:h-[10px] after:bg-[#FD6767] after:opacity-40 after:-z-10'
                  : ''
              }`}
            >
              {planDetail.name}
            </span>
          </span>
        </p>
      )}
    </>
  )
}
